import { createContext, useContext } from 'react';
import { IRootStore } from '../store/store';
import I18n from 'src/app/i18n';

const initialStore = {
  isStoreReady: false,
  i18n: I18n,
  dynamicModal: {},
} as unknown as IRootStore;

const RootStoreContext = createContext<IRootStore>(initialStore);

const useStore = () => {
  return useContext(RootStoreContext);
};

export { useStore, RootStoreContext, initialStore };
